import { useState, useEffect } from "react";

const useSubRightPermissionsHook = () => {
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const rights = JSON.parse(localStorage.getItem("rights"));
    const cleanedData = rights ? JSON.parse(rights.replace(/\\/g, "")) : [];
    if (!cleanedData) return;

    try {
      const perms = {};

      cleanedData.forEach((role) => {
        role.children?.forEach((child) => {
          if (child.subrights) {
            child.subrights?.forEach((subright) => {
              const subrightPermKeyBase = subright.title.replace(/\s+/g, "");
              const subrightPermKeys = Object.keys(subright.permissions);

              subrightPermKeys.forEach((perm) => {
                const subrightPermissionName = `${subrightPermKeyBase}.${perm}`;
                perms[subrightPermissionName] = !!subright.permissions[perm];
              });
            });
          }
        });
      });

      setPermissions(perms);
    } catch (error) {
      console.error("Failed to parse rights JSON:", error);
    }
  }, []);

  const hasSubRightPermission = (entity, action) => {
    if (action === "hasNoPermission") return true;
    if (entity && action) {
      const normalizedEntity = entity.toLowerCase().replace(/\s/g, "");
      if (
        normalizedEntity === "valuerfirm" ||
        normalizedEntity === "registry" ||
        normalizedEntity === "carmodels" ||
        normalizedEntity === "carmodel" ||
        normalizedEntity === "carmakes" ||
        normalizedEntity === "carmake"
      ) {
        const siblingKey = `CollateralAssetType.${action}`;
        return permissions[siblingKey] ?? permissions[`CarModels.${action}`] ?? true;
      }
      const permKey = `${entity.replace(/\s+/g, "")}.${action}`;
      const log = permissions[permKey];
      return log ?? false;
    }
    return false;
  };

  return { permissions, hasSubRightPermission };
};

export default useSubRightPermissionsHook;
